export const topBars: { [lang: string]: TopBar } = {
  en: {
    type: 'multi',
    slides: [
      {
        content: 'Risk free shopping! Free returns for 100 days.',
      },
      {
        content: 'Choose convenience – opt for cash on delivery.',
      },
      {
        content: '-20 EUR for purchases over 100 EUR',
      },
    ],
  },
  sk: {
    type: 'multi',
    slides: [
      { content: 'Doprava zdarma od 70 EUR.' },
      { content: 'Nákupy bez rizika. Bezplatné vrátenie do 100 dní.' },
      { content: '-20 EUR pri nákupe nad 100 EUR' },
    ],
  },
  cs: {
    type: 'multi',
    slides: [
      { content: 'Doprava zdarma od 1700 Kč.' },
      { content: 'Nákupy bez rizika. Bezplatné vrácení do 100 dnú.' },
      { content: '-400 CZK při nákupu nad 2000 CZK' },
    ],
  },
};

export type TopBar = {
  type: TopBarType;
  slides: { content: string; url?: string }[];
  timerSlide?: { content: string; url?: string };
};

export type TopBarType = 'single' | 'multi' | 'promo';
